import './VideoScriptStepsLine.css';
import React from 'react';
import { ReactComponent as IconCheck } from '../../../resources/icons/check-box-white.svg';
const VideoScriptStepsLine = _ref => {
  let {
    rtl,
    stepNames,
    currentStepId,
    className
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles} ${className}`
  }, /*#__PURE__*/React.createElement("div", {
    className: "steps-wrapper"
  }, !!stepNames.length && stepNames.map((step, i) => {
    return /*#__PURE__*/React.createElement("div", {
      key: step,
      className: `step ${i === currentStepId ? 'step--active' : ''} ${i === stepNames.length - 1 ? 'step--last' : ''}`
    }, /*#__PURE__*/React.createElement("div", {
      className: "step__content"
    }, /*#__PURE__*/React.createElement("div", {
      className: "step__name"
    }, step), /*#__PURE__*/React.createElement("div", {
      className: "step__number"
    }, currentStepId <= i ? i + 1 : /*#__PURE__*/React.createElement(IconCheck, {
      className: "iconCheck"
    }))));
  })));
};
VideoScriptStepsLine.displayName = "VideoScriptStepsLine";
export { VideoScriptStepsLine };
const commonStyles = "cnbgsyv";
const rtlStyles = "rh6iwnm";
const ltrStyles = "lh07lo";